// Χαρτογράφηση γνωστών πόλεων/κωμοπόλεων στον νομό τους — ώστε η αναζήτηση
// περιοχής να βρίσκει τον σωστό νομό ακόμα κι όταν ο χρήστης πληκτρολογεί
// την πόλη του αντί για το επίσημο όνομα του νομού (π.χ. "Ναύπλιο" -> "Αργολίδας").
// Δεν είναι εξαντλητική λίστα όλων των οικισμών — καλύπτει τις πιο γνωστές
// πόλεις κάθε νομού, αρκετό για πρακτική χρήση.
export const TOWN_TO_REGION: Record<string, string> = {
  'Αγρίνιο': 'Αιτωλοακαρνανίας',
  'Μεσολόγγι': 'Αιτωλοακαρνανίας',
  'Ναύπακτος': 'Αιτωλοακαρνανίας',
  'Ναύπλιο': 'Αργολίδας',
  'Άργος': 'Αργολίδας',
  'Κρανίδι': 'Αργολίδας',
  'Τρίπολη': 'Αρκαδίας',
  'Μεγαλόπολη': 'Αρκαδίας',
  'Λεωνίδιο': 'Αρκαδίας',
  'Άρτα': 'Άρτας',
  'Αθήνα': 'Αττικής',
  'Πειραιάς': 'Αττικής',
  'Ελευσίνα': 'Αττικής',
  'Μαραθώνας': 'Αττικής',
  'Λαύριο': 'Αττικής',
  'Μέγαρα': 'Αττικής',
  'Γλυφάδα': 'Αττικής',
  'Κηφισιά': 'Αττικής',
  'Μαρούσι': 'Αττικής',
  'Πάτρα': 'Αχαΐας',
  'Αίγιο': 'Αχαΐας',
  'Καλάβρυτα': 'Αχαΐας',
  'Λιβαδειά': 'Βοιωτίας',
  'Θήβα': 'Βοιωτίας',
  'Αλίαρτος': 'Βοιωτίας',
  'Γρεβενά': 'Γρεβενών',
  'Δράμα': 'Δράμας',
  'Ρόδος': 'Δωδεκανήσου',
  'Κως': 'Δωδεκανήσου',
  'Κάλυμνος': 'Δωδεκανήσου',
  'Αλεξανδρούπολη': 'Έβρου',
  'Ορεστιάδα': 'Έβρου',
  'Διδυμότειχο': 'Έβρου',
  'Χαλκίδα': 'Ευβοίας',
  'Κύμη': 'Ευβοίας',
  'Κάρυστος': 'Ευβοίας',
  'Καρπενήσι': 'Ευρυτανίας',
  'Ζάκυνθος': 'Ζακύνθου',
  'Πύργος': 'Ηλείας',
  'Αμαλιάδα': 'Ηλείας',
  'Ζαχάρω': 'Ηλείας',
  'Βέροια': 'Ημαθίας',
  'Νάουσα': 'Ημαθίας',
  'Αλεξάνδρεια': 'Ημαθίας',
  'Ηράκλειο': 'Ηρακλείου',
  'Μοίρες': 'Ηρακλείου',
  'Αρχάνες': 'Ηρακλείου',
  'Ηγουμενίτσα': 'Θεσπρωτίας',
  'Παραμυθιά': 'Θεσπρωτίας',
  'Θεσσαλονίκη': 'Θεσσαλονίκης',
  'Καλαμαριά': 'Θεσσαλονίκης',
  'Ιωάννινα': 'Ιωαννίνων',
  'Μέτσοβο': 'Ιωαννίνων',
  'Καβάλα': 'Καβάλας',
  'Χρυσούπολη': 'Καβάλας',
  'Καρδίτσα': 'Καρδίτσας',
  'Μουζάκι': 'Καρδίτσας',
  'Καστοριά': 'Καστοριάς',
  'Κέρκυρα': 'Κέρκυρας',
  'Αργοστόλι': 'Κεφαλληνίας',
  'Ληξούρι': 'Κεφαλληνίας',
  'Κιλκίς': 'Κιλκίς',
  'Κοζάνη': 'Κοζάνης',
  'Πτολεμαΐδα': 'Κοζάνης',
  'Κόρινθος': 'Κορινθίας',
  'Λουτράκι': 'Κορινθίας',
  'Ξυλόκαστρο': 'Κορινθίας',
  'Ερμούπολη': 'Κυκλάδων',
  'Σύρος': 'Κυκλάδων',
  'Μύκονος': 'Κυκλάδων',
  'Σαντορίνη': 'Κυκλάδων',
  'Θήρα': 'Κυκλάδων',
  'Πάρος': 'Κυκλάδων',
  'Νάξος': 'Κυκλάδων',
  'Σπάρτη': 'Λακωνίας',
  'Γύθειο': 'Λακωνίας',
  'Μονεμβασιά': 'Λακωνίας',
  'Λάρισα': 'Λάρισας',
  'Τύρναβος': 'Λάρισας',
  'Ελασσόνα': 'Λάρισας',
  'Άγιος Νικόλαος': 'Λασιθίου',
  'Ιεράπετρα': 'Λασιθίου',
  'Σητεία': 'Λασιθίου',
  'Μυτιλήνη': 'Λέσβου',
  'Λευκάδα': 'Λευκάδας',
  'Βόλος': 'Μαγνησίας',
  'Νέα Ιωνία': 'Μαγνησίας',
  'Σκιάθος': 'Μαγνησίας',
  'Καλαμάτα': 'Μεσσηνίας',
  'Μεσσήνη': 'Μεσσηνίας',
  'Πύλος': 'Μεσσηνίας',
  'Ξάνθη': 'Ξάνθης',
  'Έδεσσα': 'Πέλλας',
  'Γιαννιτσά': 'Πέλλας',
  'Κατερίνη': 'Πιερίας',
  'Λιτόχωρο': 'Πιερίας',
  'Πρέβεζα': 'Πρέβεζας',
  'Ρέθυμνο': 'Ρεθύμνου',
  'Κομοτηνή': 'Ροδόπης',
  'Σάμος': 'Σάμου',
  'Βαθύ': 'Σάμου',
  'Σέρρες': 'Σερρών',
  'Τρίκαλα': 'Τρικάλων',
  'Καλαμπάκα': 'Τρικάλων',
  'Λαμία': 'Φθιώτιδας',
  'Στυλίδα': 'Φθιώτιδας',
  'Αταλάντη': 'Φθιώτιδας',
  'Φλώρινα': 'Φλώρινας',
  'Αμύνταιο': 'Φλώρινας',
  'Άμφισσα': 'Φωκίδας',
  'Ιτέα': 'Φωκίδας',
  'Δελφοί': 'Φωκίδας',
  'Πολύγυρος': 'Χαλκιδικής',
  'Κασσάνδρεια': 'Χαλκιδικής',
  'Νέα Μουδανιά': 'Χαλκιδικής',
  'Χανιά': 'Χανίων',
  'Κίσσαμος': 'Χανίων',
  'Χίος': 'Χίου',
};

// Πρόθεμα ταχυδρομικού κώδικα (τα 2 πρώτα ψηφία) -> νομός. Οι ταχυδρομικοί
// κώδικες στην Ελλάδα είναι ιστορικά οργανωμένοι ανά νομό σε ζώνες — δεν
// είναι 100% ακριβές σε κάθε άκρο ζώνης, αλλά αρκετό για να προτείνει τον
// σωστό νομό όταν ο χρήστης πληκτρολογεί Τ.Κ. αντί για όνομα.
const POSTCODE_PREFIX_TO_REGION: Record<string, string> = {
  '10': 'Αττικής', '11': 'Αττικής', '12': 'Αττικής', '13': 'Αττικής',
  '14': 'Αττικής', '15': 'Αττικής', '16': 'Αττικής', '17': 'Αττικής',
  '18': 'Αττικής', '19': 'Αττικής',
  '20': 'Κορινθίας', '21': 'Αργολίδας', '22': 'Αρκαδίας', '23': 'Λακωνίας',
  '24': 'Μεσσηνίας', '25': 'Ηλείας', '26': 'Αχαΐας', '27': 'Ηλείας',
  '28': 'Κεφαλληνίας', '29': 'Ζακύνθου',
  '30': 'Αιτωλοακαρνανίας', '31': 'Λευκάδας', '32': 'Βοιωτίας',
  '33': 'Φωκίδας', '34': 'Ευβοίας', '35': 'Φθιώτιδας', '36': 'Ευρυτανίας',
  '37': 'Μαγνησίας', '38': 'Μαγνησίας',
  '40': 'Λάρισας', '41': 'Λάρισας', '42': 'Τρικάλων', '43': 'Καρδίτσας',
  '44': 'Γρεβενών', '45': 'Ιωαννίνων', '46': 'Θεσπρωτίας', '47': 'Άρτας',
  '48': 'Πρέβεζας', '49': 'Κέρκυρας',
  '50': 'Κοζάνης', '51': 'Καστοριάς', '52': 'Φλώρινας',
  '54': 'Θεσσαλονίκης', '55': 'Θεσσαλονίκης', '56': 'Θεσσαλονίκης', '57': 'Θεσσαλονίκης',
  '58': 'Κιλκίς', '59': 'Πέλλας',
  '60': 'Πιερίας', '61': 'Πιερίας', '62': 'Σερρών', '63': 'Χαλκιδικής',
  '64': 'Καβάλας', '65': 'Καβάλας', '66': 'Ξάνθης', '67': 'Ροδόπης', '68': 'Έβρου',
  '70': 'Ηρακλείου', '71': 'Ηρακλείου', '72': 'Λασιθίου',
  '73': 'Χανίων', '74': 'Χανίων', '75': 'Ρεθύμνου',
  '80': 'Σάμου', '81': 'Δωδεκανήσου', '82': 'Λέσβου', '83': 'Σάμου',
  '84': 'Κυκλάδων', '85': 'Δωδεκανήσου',
};

/** Επιστρέφει true αν το ερώτημα ταιριάζει είτε στο ίδιο το όνομα του νομού,
 * είτε σε γνωστή πόλη του, είτε (αν είναι αριθμός) στη ζώνη ταχυδρομικού
 * κώδικα του νομού. */
export function regionMatchesQuery(regionName: string, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  if (regionName.toLowerCase().includes(q)) return true;
  if (/^\d{2,5}$/.test(q) && POSTCODE_PREFIX_TO_REGION[q.slice(0, 2)] === regionName) return true;
  return Object.entries(TOWN_TO_REGION).some(
    ([town, region]) => region === regionName && town.toLowerCase().includes(q),
  );
}
